<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <template v-if="confirmModal.message">
              <slot name="header">
                <h3 v-translate>Message</h3>
              </slot>
            </template>
            <template v-else>
              <slot name="header">
                <h3 v-translate>Please confirm action</h3>
              </slot>
            </template>
          </div>
          <div class="modal-body">
            <slot name="body">
              <template v-if="confirmModal.message">
                <translate>An update has been released, after OK has been clicked you will be logout. Login again to continue your work. Thank you!</translate>
              </template>
              <template v-else>
                <translate>Do you want to</translate>
                {{ confirmModal.action }} ?
              </template>
            </slot>
          </div>
          <div class="modal-footer">
            <slot name="footer">
              <button
                class="btn btn-default modal-default-button px-4"
                @click="confirm"
                v-translate
              >Ok</button>
              <button
                class="btn btn-default modal-default-button px-4"
                @click="cancel"
                v-translate
              >Cancel</button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { SET_CONFIRM_MODAL } from "@/store/mutation-types";
import { SET_STAFF_STATION } from '@/store/action-types';

export default {
  name: "ConfirmModal",
  computed: {
    ...mapState({
      confirmModal: state => state.toggle.confirmModal,
      isLoading: state => state.toggle.isLoading
    })
  },
  data() {
    return {
      confirmed: false,
    }
  },
  methods: {
    async confirm() {
      if (this.confirmed) return;
      if (this.confirmModal) {
        this.confirmed = true;
        if (this.confirmModal.data 
            && this.confirmModal.data.setStationNull
        ) {
          await this.$store.dispatch(
                  SET_STAFF_STATION, 
                  { 
                    staffId: this.confirmModal.data.staffId, 
                    station: null 
                  }
                );
          await this.confirmModal.func.apply(
              this.confirmModal.context,
              this.confirmModal.args || []
            );
        } else {
          await this.confirmModal.func.apply(
            this.confirmModal.context,
            this.confirmModal.args || []
          );
        }

        if (this.confirmModal 
            && this.confirmModal.data 
            && this.confirmModal.data.setStationNull
        ) {
          this.$store.commit(SET_CONFIRM_MODAL, null);
        }
      }
    },
    cancel() {
      if(this.isLoading) return;
      this.$store.commit(SET_CONFIRM_MODAL, null);
    },
    ...mapMutations([SET_CONFIRM_MODAL])
  },
  watch: {
    isLoading: {
      handler(after) {
        if (this.confirmModal.noCloseOnLoaded) return;
        if (!after 
            && ( !this.confirmModal.data 
                  || !this.confirmModal.data.setStationNull
                )
        ) {
          this.$store.commit(SET_CONFIRM_MODAL, null);
        }
      }
    }
  }
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 4;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 360px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
  text-align: center;
  width: 100%;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
